import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Logout from '@/pages/Logout'
// import Dashboard from '@/pages/Dashboard'
import Opportunities from '@/pages/Opportunities'
import AddOpportunities from '@/pages/AddOpportunities'
import OpportunitiesDetail from '@/pages/OpportunitiesDetail'
import OpportunitiesBid from '@/pages/OpportunitiesBid'
import Organizations from '@/pages/Organizations'
import AddOrganizations from '@/pages/AddOrganizations'
import Activities from '@/pages/Activities'
import SearchOrganizations from '@/pages/SearchOrganizations'
import OrganizationsDetail from '@/pages/OrganizationsDetail'
import Contact from '@/pages/Contact'
import AddContacts from '@/pages/AddContacts'
import ContactDetail from '@/pages/ContactDetail'
import AddOrgToContact from '@/pages/AddOrgToContact'
import Addresses from '@/pages/Addresses'
import AddAddresses from '@/pages/AddAddresses'
import AddressesDetail from '@/pages/AddressesDetail'
import AddAddressesOrg from '@/pages/AddAddressesOrg'
import EditAddressesOrg from '@/pages/EditAddressesOrg'
import EditOrgToContact from '@/pages/EditOrgToContact'
import EditAddresses from '@/pages/EditAddresses'
import Tags from '@/pages/Tags'
import EditContacts from '@/pages/EditContacts'
import BidDetail from '@/pages/BidDetail'
import SetupProfile from '@/pages/SetupProfile'
import Inbox from '@/pages/Inbox'
import AddAddressesFromOrg from '@/pages/AddAddressesFromOrg'
import AddContactFromOrg from '@/pages/AddContactFromOrg'
import CreateContactFromOrg from '@/pages/CreateContactFromOrg'
import UserScheduleWorking from '@/pages/UserScheduleWorking'
import { authenticationService } from '../services/authentication.service'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Opportunities,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Table',
        page: 'Opportunity'
      }
    },
    {
      path: '/account/logout',
      name: 'Logout',
      component: Logout,
      meta: {
      }
    },
    {
      path: '/mpg/opportunities',
      component: Opportunities,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Table',
        page: 'Opportunity'
      }
    },
    {
      path: '/mpg/opportunities/new',
      component: AddOpportunities,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Form',
        page: 'Opportunity'
      }
    },
    {
      path: '/mpg/opportunities/:id/edit',
      component: AddOpportunities,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Form',
        page: 'Opportunity'
      }
    },
    {
      path: '/mpg/opportunities/:id/bid/new',
      component: OpportunitiesBid,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Details',
        page: 'Bid'
      }
    },
    {
      path: '/mpg/opportunities/:id/bid/:bidId',
      component: BidDetail,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Details',
        page: 'Bid'
      }
    },
    {
      path: '/mpg/opportunities/:id/bid/:bidId/edit-from-bid',
      component: OpportunitiesBid,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Details',
        page: 'Bid'
      }
    },
    {
      path: '/mpg/opportunities/:id/:type',
      component: OpportunitiesDetail,
      meta: {
        authorize: true,
        title: 'Opportunities',
        type: 'Details',
        page: 'Opportunity'
      }
    },
    {
      path: '/mpg/organizations',
      component: Organizations,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Table',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/create',
      component: AddOrganizations,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/:id/edit',
      component: AddOrganizations,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/:id/address/add',
      component: AddAddressesFromOrg,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/:id/contact/create',
      component: CreateContactFromOrg,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/:id/contact/add',
      component: AddContactFromOrg,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/experian/search',
      component: SearchOrganizations,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Form',
        page: 'Organizations'
      }
    },
    {
      path: '/mpg/organizations/:id/:type',
      component: OrganizationsDetail,
      meta: {
        authorize: true,
        title: 'Organizations',
        type: 'Details',
        page: 'Organizations'
      }
    },
    {
      path: '/activities',
      component: Activities,
      meta: {
        authorize: true,
        title: 'Activities',
        type: 'MPG',
        page: 'Activity'
      }
    },
    {
      path: '/mpg/contacts',
      component: Contact,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Table',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/contacts/create',
      component: AddContacts,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Form',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/contacts/:id/edit',
      component: EditContacts,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Form',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/contacts/:id/organization/add',
      component: AddOrgToContact,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Form',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/contacts/:id/organization/:orgId/edit',
      component: EditOrgToContact,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Form',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/contacts/:id/:type',
      component: ContactDetail,
      meta: {
        authorize: true,
        title: 'Contacts',
        type: 'Details',
        page: 'Contacts'
      }
    },
    {
      path: '/mpg/addresses',
      component: Addresses,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Table',
        page: 'Address'
      }
    },
    {
      path: '/mpg/addresses/:id/edit',
      component: EditAddresses,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Form',
        page: 'Address'
      }
    },
    {
      path: '/mpg/addresses/:id/organization/add',
      component: AddAddressesOrg,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Form',
        page: 'Address'
      }
    },
    {
      path: '/mpg/addresses/create',
      component: AddAddresses,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Form',
        page: 'Address'
      }
    },
    {
      path: '/mpg/addresses/:id/organization/:orgId/edit',
      component: EditAddressesOrg,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Form',
        page: 'Address'
      }
    },
    {
      path: '/mpg/addresses/:id/:type',
      component: AddressesDetail,
      meta: {
        authorize: true,
        title: 'Addresses',
        type: 'Details',
        page: 'Address'
      }
    },
    {
      path: '/mpg/tags',
      component: Tags,
      meta: {
        authorize: true,
        title: 'Tags',
        type: 'Table',
        page: 'Tags'
      }
    },
    {
      path: '/mpg/inbox',
      name: 'Inbox',
      component: Inbox,
      meta: {
        authorize: true,
        title: 'Inbox',
        type: 'Inbox',
        page: 'Message'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/setup/',
      name: 'SetupProfile',
      component: SetupProfile
    },
    {
      path: '/setup/nylas/complete',
      name: 'SetupProfileComplete',
      component: SetupProfile
    },
    {
      path: '/schedule-working',
      name: 'UserScheduleWorking',
      component: UserScheduleWorking
    },
    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta
  const currentUser = authenticationService.currentUserValue
  if (authorize) {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({ path: '/login', query: { returnUrl: to.path } })
    }

    // // check if route is restricted by role
    // if (authorize.length && !authorize.includes(currentUser.role)) {
    //   // role not authorised so redirect to home page
    //   return next({ path: '/' })
    // }
  }

  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js